import {RouteRecordName} from "vue-router";

export class NamedRouting {
  constructor(public readonly name: RouteRecordName,
              public readonly params?: any,
              public readonly query?: any) {
  }
}